import { useUserExternalAccountsQuery } from '@/modules/user-external-accounts/queries/useUserExternalAccountsQuery';
import { useCurrentUserQuery } from '@/modules/users/queries/useCurrentUserQuery';

export const useIsSlackConnected = () => {
  const currentUserQuery = useCurrentUserQuery();
  const userExternalAccountsQuery = useUserExternalAccountsQuery(
    currentUserQuery.data?.id,
  );

  const isSlackConnected =
    userExternalAccountsQuery.data?.some(
      (account) => account.type === 'Slack' && account.status === 'Active',
    ) ?? false;

  return {
    userId: currentUserQuery.data?.id,
    isSlackConnected: isSlackConnected,
  };
};
